import { 
    faPaperPlane,
    faUser,
    faExclamationCircle,
    faPhone,
    faInbox,
    faPrint,
    faHandshake,
    faClock,
    faSquareCheck,
    faNoteSticky,
    faCalendar,
    faFlag,
    faUtensils,
    faComment,
    faFileInvoice,
    faBook,
    faFolderOpen,
    faMobile,
    faTablet,
    faCarSide,
    faToolbox,
    faWrench,
    faTag,
    faCamera,
    faTruckField,
    faTrophy,
    faAlignLeft,
    faAlignCenter,
    faAlignRight,
    faQuestion,
    faBasketShopping,
    faHouse,
    faBuilding,
    faLayerGroup,
    faGear,
    faScrewdriverWrench,
    faBolt,
    faFire,
    faWind,
    faSnowflake,
    faDroplet,
    faFaucet,
    faSolarPanel,
    faChargingStation,
    faVideo,
    faDoorOpen,
    faWarehouse,
    faTruck,
    faMicrochip,
    faServer,
    faNetworkWired,
    faBatteryHalf,
    faQrcode,
    faSun,
    faUmbrellaBeach
} from '@fortawesome/free-solid-svg-icons';

import {
    faBookOpen as faBookOpenLight, faBooks, faRocketLaunch, faGraduationCap, faCircleQuestion, faLightbulb, faSliders,
    faGears, faScrewdriverWrench as faScrewdriverWrenchLight, faPlug, faMobileScreen, faCreditCard, faFileInvoice as faFileInvoiceLight,
    faCalendarDays, faClipboardCheck, faChartLine, faUsers, faEnvelope, faComments, faShieldCheck, faLifeRing,
    faPuzzlePiece, faMapLocationDot, faTruck as faTruckLight, faBoxOpen, faStar,
} from '@fortawesome/pro-light-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/*
 * iconMapping.ts
 * Map fontAwesome icons to the icon name in our platform.
 */

// The light icons of the knowledge base groups, cast because the pro light
// package ships its own copy of the icon definition type
const knowledgeBaseIcons = {
        'book-open': faBookOpenLight,
        books: faBooks,
        'rocket-launch': faRocketLaunch,
        'graduation-cap': faGraduationCap,
        'circle-question': faCircleQuestion,
        lightbulb: faLightbulb,
        sliders: faSliders,
        gears: faGears,
        'screwdriver-wrench-light': faScrewdriverWrenchLight,
        plug: faPlug,
        'mobile-screen': faMobileScreen,
        'credit-card': faCreditCard,
        'file-invoice': faFileInvoiceLight,
        'calendar-days': faCalendarDays,
        'clipboard-check': faClipboardCheck,
        'chart-line': faChartLine,
        users: faUsers,
        envelope: faEnvelope,
        comments: faComments,
        'shield-check': faShieldCheck,
        'life-ring': faLifeRing,
        'puzzle-piece': faPuzzlePiece,
        'map-location-dot': faMapLocationDot,
        'truck-light': faTruckLight,
        'box-open': faBoxOpen,
        star: faStar,
} as unknown as Record<string, IconDefinition>;

export const iconMapping = (iconName: string): IconDefinition => {
    const icons: Record<string, IconDefinition> = {
        call: faPhone,
        email: faPaperPlane,
        meeting: faHandshake,
        checkbox: faSquareCheck,
        deadline: faFlag,
        lunch: faUtensils,
        inbox: faInbox,
        print: faPrint,
        time: faClock,
        calender: faCalendar,
        note: faNoteSticky,
        chat: faComment,
        user: faUser,
        document: faFileInvoice,
        book: faBook,
        folder: faFolderOpen,
        smartphone: faMobile,
        tablet: faTablet,
        car: faCarSide,
        toolbox: faToolbox,
        wrench: faWrench,
        tag: faTag,
        camera: faCamera,
        van: faTruckField,
        trophy: faTrophy,
        alignLeft: faAlignLeft,
        alignCenter: faAlignCenter,
        alignRight: faAlignRight,
        question: faQuestion,
        basket: faBasketShopping,
        house: faHouse,
        building: faBuilding,
        'layer-group': faLayerGroup,
        gear: faGear,
        'screwdriver-wrench': faScrewdriverWrench,
        bolt: faBolt,
        fire: faFire,
        wind: faWind,
        snowflake: faSnowflake,
        droplet: faDroplet,
        faucet: faFaucet,
        'solar-panel': faSolarPanel,
        'charging-station': faChargingStation,
        sun: faSun,
        'umbrella-beach': faUmbrellaBeach,
        video: faVideo,
        'door-open': faDoorOpen,
        warehouse: faWarehouse,
        truck: faTruck,
        microchip: faMicrochip,
        server: faServer,
        'network-wired': faNetworkWired,
        'battery-half': faBatteryHalf,

        ...knowledgeBaseIcons,
    }

    return icons[iconName] || faExclamationCircle;
}